class DataPickerRegister extends HTMLElement {
  constructor() {
    super();

    this.boundHandleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
  }

  connectedCallback() {
    this.customerTypeSelect = document.getElementById('customer_type');

    this.input = this.querySelector('#expectedGraduationYear');
    this.formField = this.querySelector('#expectedGraduationYearField');

    if (this.customerTypeSelect) {
      this.customerTypeSelect.addEventListener('change', this.boundHandleCustomerTypeChange);
    }

    this.handleCustomerTypeChange();
  }

  handleCustomerTypeChange() {
    const customerType = this.customerTypeSelect?.value || this.dataset.customerType;

    this.input.value = '';
    this.clearErrorMessage();

    if (customerType === 'Law Student' || customerType === 'Undergraduate Student') {
      const currentYear = new Date().getFullYear();

      const maxYears = customerType === 'Law Student' ? 6 : 7;
      const minYear = currentYear;
      const maxYear = currentYear + maxYears;

      this.formField.setAttribute('data-min-year', minYear);
      this.formField.setAttribute('data-max-year', maxYear);
      this.formField.setAttribute('data-customer-type', customerType);
      this.formField.classList.remove('hide');
    } else {
      this.formField.classList.add('hide');
    }
  }

  clearErrorMessage() {
    if (this.errorElement) {
      this.errorElement.textContent = '';
      this.errorElement.classList.remove('show');
    }

    if (this.input) {
      this.input.classList.remove('error');
    }
  }

  disconnectedCallback() {
    if (this.customerTypeSelect) {
      this.customerTypeSelect.removeEventListener('change', this.boundHandleCustomerTypeChange);
    }

    if (this.input) {
      this.input.removeEventListener('blur', this.boundValidateYear);
      this.input.removeEventListener('change', this.boundValidateYear);
    }
  }
}

customElements.define('data-picker-register', DataPickerRegister);
